<mat-card appearance="outlined">
  <div class="forgot-password-wrapper">
    <img class="logo" alt="Vendasta" src="/static/images/vendasta-logo-large.png" />
    <ng-container *ngIf="!resetSent; else resetSentView">
      <h1 class="title">{{ 'FORGOT_PASSWORD.TITLE' | translate }}</h1>
      <p class="subtitle">
        {{ 'FORGOT_PASSWORD.SUBTITLE' | translate }}
      </p>

      <form #f="ngForm" (ngSubmit)="submitResetRequest()">
        <glxy-email-input [formControl]="emailControl"></glxy-email-input>

        <button class="send-email-button" type="submit" mat-flat-button color="primary">
          <ng-container *ngIf="!loading; else loadingSpinner">
            {{ 'FORGOT_PASSWORD.ACTION_BUTTON' | translate }}
          </ng-container>
        </button>
      </form>
    </ng-container>
  </div>
</mat-card>
<ng-template #resetSentView>
  <h1 class="title">{{ 'FORGOT_PASSWORD.CHECK_EMAIL.TITLE' | translate }}</h1>
  <p class="subtitle">
    {{ 'FORGOT_PASSWORD.CHECK_EMAIL.SUBTITLE' | translate : { email: emailControl.value } }}
  </p>
  <button class="send-email-button" type="button" mat-flat-button color="primary" (click)="resetPage()">
    {{ 'FORGOT_PASSWORD.CHECK_EMAIL.ACTION_BUTTON' | translate }}
  </button>
</ng-template>
<ng-template #loadingSpinner>
  <mat-spinner class="loading-spinner" [diameter]="20" color="secondary"></mat-spinner>
</ng-template>
